











import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class SProgress extends Vue {
  @Prop({ type: Number, default: 0 }) public loaded!: number;
  @Prop({ type: Number, default: 100 }) public max!: number;

  get percent() {
    if (this.loaded < 0) return 0;
    if (this.max <= this.loaded) return 100;
    return Math.round(this.loaded * 100 / this.max);
  }
}
